import {
  createFileRoute,
  useParams,
  Outlet,
  useLocation,
} from "@tanstack/react-router"
import {
  LayoutWithSidebar,
  DetailSidebar,
  useLayoutConfig,
  ProfileCard,
  Separator,
  NavigationItem,
} from "toptaal-shared"
import ScreenWrapper from "@/components/ScreenWrapper"
import { useOrganizationUserByIdSuspenseQuery } from "@/api/queries/organizationUser/useOrganizationUserByIdSuspenseQuery"
import { checkOrganizationPermissions } from "@/utils/checkOrganizationPermissions"

export const Route = createFileRoute("/beheer/medewerkers/$organizationUserId")(
  {
    component: Parent,
    beforeLoad: () => checkOrganizationPermissions("read", "contacts"),
  },
)

function Parent() {
  const { pathname } = useLocation()
  const layoutConfig = useLayoutConfig()

  const { organizationUserId } = useParams({
    from: "/beheer/medewerkers/$organizationUserId",
  })

  const base = `/beheer/medewerkers/${organizationUserId}`
  const sidebarNavigationItems = [
    {
      label: "Gegevens",
      to: `${base}/gegevens`,
    },
    {
      label: "Gekoppelde cursisten",
      to: `${base}/gekoppelde-cursisten`,
    },
  ]

  return (
    <ScreenWrapper className="!px-0">
      <LayoutWithSidebar
        rightPanelClassName={layoutConfig.rightPanelClassName}
        disableRightPanelSuspense={layoutConfig.disableRightPanelSuspense}
        sidebar={
          <OrganizationUserSidebar
            organizationUserId={Number(organizationUserId)}
            sidebarNavigationItems={sidebarNavigationItems}
            isItemActive={(route: string) => pathname.startsWith(route)}
          />
        }
      >
        <Outlet />
      </LayoutWithSidebar>
    </ScreenWrapper>
  )
}

function OrganizationUserSidebar({
  organizationUserId,
  sidebarNavigationItems,
  isItemActive,
}: {
  organizationUserId: number
  sidebarNavigationItems: NavigationItem[]
  isItemActive: (route: string) => boolean
}) {
  const { data: organizationUser } = useOrganizationUserByIdSuspenseQuery({
    organizationUserId,
  })

  return (
    <DetailSidebar
      items={sidebarNavigationItems}
      isItemActive={isItemActive}
      goBackLabel="Medewerkers"
      goBackRoute="/beheer/medewerkers"
    >
      <ProfileCard
        firstName={organizationUser.firstName}
        lastName={organizationUser.lastName}
        email={organizationUser.email}
        phoneNumber={organizationUser.phoneNumber}
      />

      <Separator className="my-6" />
    </DetailSidebar>
  )
}
